import { useRouter } from "next/router";
import React from "react";

type PropType = {
  callback: (ev: any) => void;
  type:
    | "routeChangeStart"
    | "routeChangeComplete"
    | "routeChangeError"
    | "beforeHistoryChange"
    | "hashChangeStart"
    | "hashChangeComplete"
    | "routeOnLoad";
};

export function useRouterEvent(props: PropType) {
  const router = useRouter();
  const isLoadedRef = React.useRef(false);

  React.useEffect(() => {
    router.events.on(props.type as any, props.callback);
    return () => router.events.off(props.type as any, props.callback);
  }, []);

  // custom on load event callback firing
  React.useEffect(() => {
    if (router.isReady && !isLoadedRef.current) {
      isLoadedRef.current = true;
      props.type === "routeOnLoad" && props.callback(router.asPath);
    }
  }, [router]);
}
